import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  const getTagStyle = (tag: string) => {
    if (tag === '独家') return 'bg-primary-500 text-background-50';
    if (tag === '最新') return 'bg-accent-500 text-background-50';
    return 'bg-secondary-500 text-background-50';
  };

  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-timer-flash-line"></i>
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">最新快讯时间线</h2>
          <p className="mt-3 text-sm text-foreground-600">分钟级更新，黑料不等待</p>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300/60 hidden md:block"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="flex gap-4 md:gap-6 items-start">
                <div className="hidden md:flex flex-col items-center flex-shrink-0 relative z-10">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                </div>
                <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200/60 transition-all cursor-pointer min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="text-xs font-mono text-primary-500 font-semibold whitespace-nowrap">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${getTagStyle(item.tag)}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 text-sm md:text-base font-semibold text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}